import Slider, { BackgroundImageSlide } from './Slider';

export default Slider;

export { BackgroundImageSlide };
